/**
 * `libphonenumber-js` carries ~350 KB of country metadata — more than any other
 * dependency the app loads eagerly, for a field that only appears on the
 * company / clients / employees forms. Load it on demand instead: consumers
 * render the raw value until `loadPhoneLib()` resolves.
 */
type PhoneLib = typeof import('libphonenumber-js');

let cached: PhoneLib | null = null;
let pending: Promise<PhoneLib> | null = null;

/** Resolves the metadata bundle, fetching it at most once per session. */
export function loadPhoneLib(): Promise<PhoneLib> {
  if (cached) return Promise.resolve(cached);
  pending ??= import('libphonenumber-js').then((mod) => {
    cached = mod;
    return mod;
  });
  return pending;
}

/** The bundle if it is already in memory, else `null` — never triggers a fetch. */
export function getLoadedPhoneLib(): PhoneLib | null {
  return cached;
}
